import alertify from 'alertifyjs'

export function errorNotify(msg) {
  alertify.set('notifier','position', 'top-right');
  alertify.error(msg);
}